import _ from "lodash";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SelectInput from "../../framework/SelectInput";
import { searchManufacturerGroup } from "../../services/manufacturer-group-services";

const ManufacturerGroupCellSelectEditor = forwardRef((props, ref) => {
  const { value } = props;

  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const id = setTimeout(
      () => inputRef.current?.focus?.({ preventScroll: true }),
      0
    );
    return () => clearTimeout(id);
  }, []);

  useEffect(() => {
    if (value) setSelected(value);
  }, [value]);

  const fetchManufacturerGroups = useCallback(async (term) => {
    const q = (term || "").trim();
    const rows = await searchManufacturerGroup({ page: 1, limit: 20, name: q });
    const opts = (rows || []).map((g) => ({
      id: g.manufacturerGroupId,
      label: g.name,
    }));
    setOptions(opts);
  }, []);

  const debouncedFetch = useMemo(
    () => _.debounce(fetchManufacturerGroups, 250),
    [fetchManufacturerGroups]
  );
  useEffect(() => {
    return () => debouncedFetch.cancel();
  }, [debouncedFetch]);

  useImperativeHandle(ref, () => ({
    getValue: () => selected,
    isCancelAfterEnd: () => false,
  }));

  return (
    <div className="ag-grid-select-input">
      <SelectInput
        ref={inputRef}
        value={selected}
        options={options}
        freeSolo
        openOnFocus={true}
        getOptionLabel={(option) => option?.label || option}
        isOptionEqualToValue={(option, value) => {
          const optionId = option?.id ?? option?.manufacturerGroupId;
          const valueId = value?.id ?? value?.manufacturerGroupId;
          if (optionId && valueId) return optionId === valueId;
          return option?.label === (value?.label || value);
        }}
        onChange={(e, newValue) => setSelected(newValue)}
        onFocus={() => {
          // Trigger search immediately on focus
          fetchManufacturerGroups("");
        }}
        onInputChange={(e, val, reason) => {
          if (reason === "reset") return;
          debouncedFetch(typeof val === "string" ? val : e?.target?.value || "");
        }}
        InputProps={{ style: { background: "white" } }}
      />
    </div>
  );
});

export default ManufacturerGroupCellSelectEditor;
